import styled, { css } from 'styled-components'
import * as S from 'components/templates/styled'
import { AVAILABLE_BRANDS, theme } from 'styles/theme'
import { getSize } from 'utils'

export const Container = styled(S.Container)`
  padding-top: ${getSize(114)};
  display: grid;
  column-gap: ${getSize(30)};
  row-gap: 0;
  position: relative;
  z-index: 2;

  .background-image,
  .background-video {
    z-index: -1;
    opacity: 1;
  }

  @media (max-aspect-ratio: 1/1) {
    column-gap: 0;
  }
`

export const SportFigure = styled.div`
  grid-area: sport-figure;
  width: 100%;
  height: 100%;
  padding-bottom: ${getSize(95)};
  box-sizing: border-box;
  text-align: center;

  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }

  @media (max-aspect-ratio: 1/1) {
    padding-bottom: 0;
  }
`

export const Image = styled.div`
  width: ${getSize(248)};
  height: ${getSize(248)};
  background-image: url(${props => props.src});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`

export const AuthorInfo = styled.div`
  grid-area: author-info;
  justify-self: flex-end;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: ${getSize(105)};

  .text-content {
    padding: ${getSize(30)} ${getSize(40)} ${getSize(22)};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    position: relative;
    width: ${getSize(492)};
  }

  .author {
    font-weight: 700;
    line-height: ${getSize(45)};
    margin: 0;
    margin-bottom: ${getSize(12)};
    ${({ theme: { color } }) =>
      (color === AVAILABLE_BRANDS.CLOUD_LIGHT || color === AVAILABLE_BRANDS.CLOUD_DARK) &&
      css`
        color: ${theme.colors.white};
        font-size: ${getSize(54)};
        font-family: 'Bison';
      `}
  }

  .position {
    font-size: ${getSize(20)};
    font-weight: 700;
    line-height: ${getSize(30)};
    text-transform: uppercase;
    ${({ theme: { color } }) =>
      (color === AVAILABLE_BRANDS.CLOUD_LIGHT || color === AVAILABLE_BRANDS.CLOUD_DARK) &&
      css`
        color: ${theme.colors.white};
        font-family: 'AzoSans';
        font-weight: 300;
      `}
  }
`

export const Quote = styled.div`
  grid-area: quote;
  height: ${getSize(456)};
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  ${({ theme: { color } }) =>
    (color === AVAILABLE_BRANDS.CLOUD_LIGHT || color === AVAILABLE_BRANDS.CLOUD_DARK) &&
    css`
      font-family: 'Poppins';
    `}
  svg {
    width: auto;
    height: ${getSize(97)};
    position: absolute;
    top: ${({ theme: { color } }) =>
      color === AVAILABLE_BRANDS.CLOUD_LIGHT || color === AVAILABLE_BRANDS.CLOUD_DARK ? getSize(-36) : getSize(-18)};

    path {
      ${({ theme: { color } }) =>
        (color === AVAILABLE_BRANDS.CLOUD_LIGHT || color === AVAILABLE_BRANDS.CLOUD_DARK) &&
        css`
          fill: ${theme.colors.limeGreen};
        `}
    }
  }

  .quote {
    text-align: left;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    ${({ theme: { color } }) =>
      (color === AVAILABLE_BRANDS.CLOUD_LIGHT || color === AVAILABLE_BRANDS.CLOUD_DARK) &&
      css`
        font-weight: 400;
      `}
  }
`
export const Footer = styled.div`
  height: 15vw;
  display: none;
`
